function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.53426 4.66396H1.8892C1.76857 4.66396 1.67077 4.76176 1.67077 4.88239V14.7117C1.67077 14.8324 1.76857 14.9302 1.8892 14.9302H9.53426C9.65489 14.9302 9.75269 14.8324 9.75269 14.7117V4.88239C9.75269 4.76176 9.65489 4.66396 9.53426 4.66396ZM1.8892 3.24417C0.984435 3.24417 0.250977 3.97763 0.250977 4.88239V14.7117C0.250977 15.6165 0.984435 16.35 1.8892 16.35H9.53426C10.439 16.35 11.1725 15.6165 11.1725 14.7117V4.88239C11.1725 3.97763 10.439 3.24417 9.53426 3.24417H1.8892Z",
  fill: "#249AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.8175 2.6981C2.8175 1.40127 3.86879 0.349976 5.16563 0.349976H11.7185C13.0154 0.349976 14.0667 1.40127 14.0667 2.6981V11.4353C14.0667 12.7321 13.0154 13.7834 11.7185 13.7834V12.3636C12.2312 12.3636 12.6469 11.948 12.6469 11.4353V2.6981C12.6469 2.1854 12.2312 1.76977 11.7185 1.76977H5.16563C4.65293 1.76977 4.2373 2.1854 4.2373 2.6981H2.8175Z",
  fill: "#249AF3"
});

function SvgDuplicateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/DuplicateIcon.bea8f32f.svg";
export { ForwardRef as ReactComponent };